import { colors, spacing, radius, typography } from '../tokens';
const baseButton = {
    padding: `${spacing[3]} ${spacing[4]}`,
    fontSize: typography.fontSize.md,
    fontWeight: typography.fontWeight.medium,
    border: 'none',
    borderRadius: radius.md,
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing[2],
};
export const buttonStyles = {
    primary: {
        ...baseButton,
        backgroundColor: colors.primary[500],
        color: colors.white,
    },
    secondary: {
        ...baseButton,
        backgroundColor: colors.gray[100],
        color: colors.gray[900],
    },
    outline: {
        ...baseButton,
        backgroundColor: 'transparent',
        color: colors.primary[500],
        border: `1px solid ${colors.primary[500]}`,
    },
    danger: {
        ...baseButton,
        backgroundColor: 'transparent',
        color: colors.error.DEFAULT,
        border: `1px solid ${colors.error.DEFAULT}`,
    },
    ghost: {
        ...baseButton,
        backgroundColor: 'transparent',
        color: colors.primary[500],
        padding: spacing[2],
    },
};
//# sourceMappingURL=button.js.map